export enum CurrencyCode {
  USD = "USD",
  JPY = "JPY",
  KRW = "KRW",
  uBTC = "uBTC",
  USDT = "USDT",
  XRP = "XRP",
  mLTC = "mLTC",
  mBCH = "mBCH",
  USDC = "USDC",
  mETH = "mETH",
}

export const currencyCodeOptions = Object.values(CurrencyCode);